import { render, staticRenderFns } from "./TimelinePerson.vue?vue&type=template&id=9cf72e68&scoped=true"
import script from "./TimelinePerson.vue?vue&type=script&lang=js"
export * from "./TimelinePerson.vue?vue&type=script&lang=js"
import style0 from "./TimelinePerson.vue?vue&type=style&index=0&id=9cf72e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf72e68",
  null
  
)

export default component.exports